export const tco2e = (
  <small>
    tCO<sub>2</sub>e
  </small>
);
